import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import { consumeReturnTo, login as startLogin } from "../auth/keycloak";
import useInitTimeout from "../auth/useInitTimeout";
import { AuthError, AuthLoading } from "../auth/AuthStates";

const KeycloakCallback = () => {
  const { keycloak, initialized } = useKeycloak();
  const navigate = useNavigate();
  const timedOut = useInitTimeout(initialized);
  const [loginRequested, setLoginRequested] = useState(false);

  useEffect(() => {
    if (initialized && keycloak.authenticated) {
      navigate(consumeReturnTo(), { replace: true });
      return;
    }

    // No valid session (for example, after logout): go straight to the
    // Keycloak login page instead of showing an intermediate screen.
    if (initialized && !keycloak.authenticated && !loginRequested) {
      setLoginRequested(true);
      startLogin();
    }
  }, [
    initialized,
    keycloak.authenticated,
    loginRequested,
    navigate,
  ]);

  if (timedOut) {
    return <AuthError onRetry={() => window.location.reload()} />;
  }

  return <AuthLoading message="Завершаем вход..." />;
};

export default KeycloakCallback;
